<template>
  <div class="loading-indicator" aria-hidden="true">
    <Icon :color="color" type="loading" />
  </div>
</template>

<script>
import { color } from 'defaults';
import Icon from '../../icons';

export default {
  components: {
    Icon,
  },
  props: {
    color: {
      type: String,
      default: color,
    },
  },
};
</script>
